import script from "./AppInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./AppInfo.vue?vue&type=script&setup=true&lang=js"

import "./AppInfo.vue?vue&type=style&index=0&id=1712fbdc&lang=scss&scoped=true"
import "./AppInfo.vue?vue&type=style&index=1&id=1712fbdc&lang=scss"

import exportComponent from "/tmp/tesla_data/tmp/apply_3091/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1712fbdc"]])

export default __exports__